type NavigationPath = string | { path: string }

type NavigationItem = {
  path: NavigationPath
  children?: NavigationItem[]
}

type NormalizePath = (path: string) => string

const pathValue = (path: NavigationPath) => (typeof path === 'string' ? path : path.path)

const matchScore = (
  item: NavigationItem,
  currentPath: string,
  normalizePath: NormalizePath,
  depth = 0,
): number => {
  const itemPath = pathValue(item.path)
  let score = 0

  if (!itemPath.startsWith('#') && !/^https?:\/\//.test(itemPath)) {
    const targetPath = normalizePath(itemPath)

    if (currentPath === targetPath) score = 2_000 + depth
    else if (currentPath.startsWith(`${targetPath}/`)) score = 1_000 + depth
  }

  for (const child of item.children ?? []) {
    score = Math.max(score, matchScore(child, currentPath, normalizePath, depth + 1))
  }

  return score
}

export const findActiveNavigationIndex = (
  items: NavigationItem[],
  path: string,
  normalizePath: NormalizePath = (value) => value,
) => {
  const currentPath = normalizePath(path)
  let activeIndex = -1
  let activeScore = 0

  items.forEach((item, index) => {
    const score = matchScore(item, currentPath, normalizePath)
    if (score > activeScore) {
      activeIndex = index
      activeScore = score
    }
  })

  return activeIndex
}
